export default {
	TEST_DRIVE: 'Test Drive',
	INFO_REQUEST: 'Request More Info',
	EMAIL_A_FRIEND: 'Email a Friend',
	SPECIALS_EMAIL_A_FRIEND: 'Email a Friend',
	CONTACT: 'General Contact',
	PREQUAL: 'Prequal',
	PARTS_ORDER: 'Parts',
	SCHEDULE_A_TEST_DRIVE: 'Test Drive',
	SERVICE_APPT: 'Schedule Service',
	BODYSHOP: 'Service',
	EMPLOYMENT: 'Employment',
	TRADE_IN: 'Trade In',
	FINANCE: 'Finance',
	SPECIALS_INFO_REQUEST: 'Specials',
	INVENTORYFINDER: 'Vehicle Finder',
	MAKE_AN_OFFER: 'Make an Offer',
	SHOWROOM: 'Request More Info',
	VEHICLE_LEAD: 'Request More Info',
	INVENTORY_SEARCH_LEAD: 'Vehicle Finder',
	MSLP: 'Request More Info',
	GLOBAL_VEHICLE_INCENTIVE_LEAD: 'Specials',
	BUILD_AND_PRICE: 'Get a Quote',
	EPRICE: 'Get a Quote',
	DEFAULT: 'Other'
};
